import React from 'react';
import ComponentErp from './ComponentErp.js';
import store from '../store';

import FormEdit from '../components/FormEdit.js';
import { GetFornecedoresEndAPI } from '../models/ModelFornecedoresEnd.js';
import FornecedoresEnderecoUpdate from './FornecedoresEnderecoUpdate.js';

class FornecedoresEndereco extends ComponentErp {

  constructor(props) {
    super(props);
    this.state = store.getState().fornecedores.enderecos;
    const script = document.createElement("script");

    script.src = "/assets/js/admin-materialize.min.js?v=1";
    script.async = true;

    document.body.appendChild(script);
  }

  componentDidMount() {
    this.callApi(1)
  }

  componentDidUpdate(prevProps, prevState) {

    var response = {};
    if ((store.getState().fornecedores.enderecos.refresh === 'listaendereco' &&
      store.getState().fornecedores.enderecos.id_fornecedor !== store.getState().fornecedores.cadastro.id
    )) {
      response = { type: 'FORNECEDORES.ENDERECO.TOOGLE_REFRESH' }
      this.updateRedux(response);
      this.callApi(1);
    }

    if (this.state.refresh === 'buscando') {
      response = {
        refresh: 'concluido',
        btnCadastro: <FornecedoresEnderecoUpdate
          id_fornecedor={this.state.id_fornecedor}
          id_fornecedor_end={this.state.id_fornecedor_end}
          refresh='buscando'
          returnComponentRefresh={this.returnComponentRefresh}
        />
      }

      this.setState(response);

    }

    if (this.state.refresh === 'limpando') {
      this.callApi(0);
      response = {
        refresh: 'concluido',
        id_fornecedor: this.state.id_fornecedor,
        id_fornecedor_end: 0,
        btnCadastro: this.btnCadastroNovo()
      }
      this.setState(response);

    }

  }

  btnCadastroNovo = () => {
    return (<><FormEdit
      id='cadNovoEnd'
      label='Novo Cadastro'
      styleDiv='submit'
      onClick={this.novoCadastro}
      styleField='submit'
      typeField='button'
      icon='adiciona' />

      <FormEdit
        id='AtualizaEnd'
        label='Atualizar'
        styleDiv='submit'
        onClick={() => this.callApi(1)}
        styleField='submit'
        typeField='button'
        icon='atualiza' />
    </>)
  }

  callBackPaginacao = (response) => {
    response.refresh = 'buscafornecedorendereco';
    response.type = 'FORNECEDORES.ENDERECO.' + response.type;
    this.updateReduxAndState(response);
  }

  async callApi(modal) {
    var grids = store.getState().fornecedores.enderecos;

    var response = await GetFornecedoresEndAPI(store.getState().fornecedores.cadastro.id, grids.limit, grids.offset, modal);
    response.refresh = 'concluido';
    response.callBackPaginacao = this.callBackPaginacao;
    response.btnCadastro = this.btnCadastroNovo();
    response.onClickModal = this.novoCadastro;
    response.id_fornecedor = store.getState().fornecedores.cadastro.id;

    response.type = 'FORNECEDORES.ENDERECO.TOOGLE_LISTA';
    this.updateRedux(response);
    grids = store.getState().fornecedores.enderecos;
    this.setState(grids);

  }

  novoCadastro = (event, id_fornecedor_end) => {
    event.preventDefault()

    this.setState({
      refresh: 'buscando',
      id_fornecedor_end: id_fornecedor_end
    });

  }


  render() {

    return (
      <div>
        <form name="form" onSubmit={this.handleSubmit} action="" method="get" encType="multipart/form-data">
          {<FormEdit id='sEndIdFornecedor' typeField='hidden'
            value={store.getState().fornecedores.enderecos.id_fornecedor}
          />}

          {<FormEdit id='sEndCnpj'
            label='Fornecedor'
            styleDiv='1'
            value={store.getState().fornecedores.enderecos.fornecedor}
            typeField='readonly'
          />}


        </form>
        {this.state.btnCadastro}
        {this.Grid(store.getState().fornecedores.enderecos)}

      </div>

    );

  }
}

export default FornecedoresEndereco;
